export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8077.cc96c70c.jpg";